var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    { staticClass: "p-4 hover:shadow-none w-full customCardConatiner" },
    [
      _c("div", { staticClass: "w-full" }, [
        _c(
          "div",
          { staticClass: "flex flex-col lg:flex-row justify-between w-full" },
          [
            _c(
              "div",
              { staticClass: "mb-2 w-40" },
              [
                _c("CardBodySingleChipReview", {
                  attrs: {
                    withAvatar: "",
                    customContainerClass: "h-auto",
                    newAvatarColor: true,
                    clickableText: false,
                    background: _vm.bgStyle(_vm.review),
                    labelStyle:
                      "text-primary-black leading-3 text-xl font-semibold",
                    chipDetails: {
                      id: _vm.contractorId,
                      name: _vm.reviewerName,
                      routeParams: _vm.reviewerRouteParams,
                    },
                  },
                }),
                _c(
                  "p",
                  {
                    staticClass:
                      "text-gray-new font-outfit text-sm font-normal pt-2 leading-6 pl-4 adjustWidthReview",
                  },
                  [_vm._v(" " + _vm._s(_vm.reviewDate) + " ")]
                ),
                _vm._t("default"),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "w-full" },
              [
                _c("RatingStars", {
                  staticClass: "-ml-0.5 mb-1 ml-auto justify-end",
                  attrs: { value: _vm.score, starSize: 20, readOnly: "" },
                }),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "text-primary-black text-base -mt-2 font-light pt-3 leading-6",
          },
          [_vm._v(" " + _vm._s(_vm.review) + " ")]
        ),
      ]),
      _vm._t("taskDeatils"),
      _vm.dialog
        ? _c("ReviewModal", {
            attrs: {
              review: _vm.review,
              score: _vm.score,
              ratingId: _vm.ratingId,
              contractorId: _vm.contractorId,
              currentUserId: _vm.currentUserId,
            },
            on: { close: _vm.toggleReviewModal, editted: _vm.handleEditted },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }